import Loadable from 'UIComponents/decorators/Loadable';
export default Loadable({
  loader: () => import(
  // @ts-expect-error: no types
  /* webpackChunkName: "object-builder-client" */
  'object-builder-ui-client').then(mod => mod.default),
  LoadingComponent: () => null
});